import type {
  LeaderboardEntry,
} from '../types';
import { PersistedState } from 'runed';

// TODO move into class?
// TODO migrate over to indexeddb
export const localLeaderboard = new PersistedState<LeaderboardEntry[]>(
  'games',
  [],
);

export const saveLocalLeaderboard = (entry: LeaderboardEntry) => {
  if (!localLeaderboard.current.find((e) => e.gameId === entry.gameId)) {
    localLeaderboard.current.push(entry);
  }
  return localLeaderboard;
};
